import type { InputRef } from 'antd'
import { Input } from 'antd'
import type { ColumnType } from 'antd/es/table/interface'
import React, { useCallback, useRef } from 'react'

import { TableFilterDropdownContainer } from '../components/TableFilterDropdownContainer/TableFilterDropdownContainer'
import { columnFilterIcon } from './useColumnFilters'

/**
 * Hook allowing custom filter function for Ant Table columns.
 */
export function useColumnCustomSearchFilter<T>() {
  const searchInput = useRef<InputRef>(null)

  const getCustomSearchFilter = useCallback(
    (
      onFilter: (value: string, record: T) => boolean,
      placeholder?: string
    ): ColumnType<T> => ({
      ...columnFilterIcon,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
        close,
      }) => (
        <TableFilterDropdownContainer
          clearFilters={clearFilters}
          confirm={confirm}
          close={close}
          isSelected={!!selectedKeys?.length}
        >
          <Input
            ref={searchInput}
            placeholder={placeholder ?? 'Vyhledat'}
            value={selectedKeys[0]}
            onChange={e =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => confirm()}
            className="!block"
          />
        </TableFilterDropdownContainer>
      ),
      onFilter: (value, record) => onFilter(value as string, record),
      filterDropdownProps: {
        onOpenChange: open => {
          if (open) setTimeout(() => searchInput.current?.select(), 100)
        },
      },
    }),
    []
  )

  return { getCustomSearchFilter }
}
